import React, { useState } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import ReferralUserComponent from "./InsidePages/ReferralUserComponent";
import ReferralVendorComponent from "./InsidePages/ReferralVendorComponent";
import ReferralSalesComponent from "./InsidePages/ReferralSalesComponent";
import ReferralPartnersComponent from "./InsidePages/ReferralPartnersComponent";
import ReferralAffiliatesComponent from "./InsidePages/ReferralAffiliatesComponent";
import AddReferralsPopup from "./referralsPopup/AddReferralsPopup";
import { Image } from "react-bootstrap";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import { useSelector } from "react-redux";
import BasicPagination from "../../../Pagination/Pagination";

export const SuperAdminReferralsCode = (props) => {
  
  const [state, setState] = useState({
    selectedTab: 1,
    error: [],
    showSearch: false,
  });

  const referralData = useSelector((state) => state.superAdminReferrals);

  const pageChangeButtonHandler = (value) => {
    setState({
      ...state,
      selectedTab: value,
    });
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation
              displayText="All Referrals Activity Report"
              displayButton="addReferrals"
            />
            <div className="super-admin-inside-right-side-panel">
              <div className="seating_dashboard_top_new_header">
                <div className="row">
                  <div className="col-6">
                    <h4>All Referrals Activity Report</h4>
                    {/* <div className="f10-400">
                        Here you can view the list of referred users, vendors,
                        affiliates, sales persons and partner
                      </div> */}
                  </div>
                  {/* <div className="col-6 text-right">
                      <AddReferralsPopup source="allrefs" />

                      <button
                        type="button"
                        class="mr-4 px-5 py-2 btn btn-outline-secondary"
                        onClick={(e) =>
                          this.props.history.push("/superadmin-refrees")
                        }
                      >
                        View Referrers
                      </button>
                      <button
                        onClick={(e) =>
                          this.props.history.push("/superadmin-referrals")
                        }
                        className="btn add_button_custom_1"
                      >
                        View Referral Codes
                      </button>
                    </div> */}
                </div>
              </div>
              <div className="row">
                {/* <div className="col-6 d-flex">
                  <div className="f10-400" align="center">
                    <Image
                      onClick={() =>
                        // this.setState({ showSearch: !this.state.showSearch })
                        setState({
                          ...state,
                          showSearch: !state.showSearch,
                        })
                      }
                      alt="filter"
                      title="filter"
                      width="80px"
                      src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                    />
                  </div>
                  <div
                    className="f10-400"
                    align="center"
                  // onClick={handleShowFilter}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div
                    className="f10-400"
                    align="center"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                  // onClick={props.handleClick}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div className="f10-400" align="center">
                    {/* <CSVDownloader
                        filename={"Super Admin videos"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      /> 
                    <br />
                  </div>
                </div> */}
                <div className="col-12">
                  <div className="d-flex justify-content-end mt-3 mb-3">
                    <RightSideCountTop
                      content={[
                        {
                          name: `${state.selectedTab === 1
                              ? "User"
                              : state.selectedTab === 2
                                ? "Merchant"
                                : state.selectedTab === 3
                                  ? "Sales Representative"
                                  : state.selectedTab === 4
                                    ? "Affiliates"
                                    : state.selectedTab === 5
                                      ? "Partners"
                                      : state.selectedTab === 6
                                        ? "Marketing"
                                        : ""
                            } Referrals`,
                          value: `${state.selectedTab === 1
                              ? referralData?.referrals?.length
                              : state.selectedTab === 2
                                ? referralData?.vendorReferrals?.length
                                : state.selectedTab === 3
                                  ? referralData?.salersReferrals?.length
                                  : state.selectedTab === 4
                                    ? referralData?.affiliatesReferrals?.length
                                    : state.selectedTab === 5
                                      ? referralData?.partnerReferrals?.length
                                      : state.selectedTab === 6
                                        ? referralData?.referrals?.length
                                        : 0
                            }`,
                          backgroundColor: "#FFEDE9",
                          color: "#EE3A23",
                        },
                        // {
                        //   name: "Business Referrals",
                        //   value: `${20}`,
                        //   backgroundColor: "#EFEBFB",
                        //   color: "#6F32C9",
                        // },
                        {
                          name: "Total amount disbursed",
                          value: `₹ ${state.selectedTab === 1
                            ? referralData?.referrals?.length * 50
                            : state.selectedTab === 2
                              ? referralData?.vendorReferrals?.length * 50
                              : state.selectedTab === 3
                                ? referralData?.salersReferrals?.length * 50
                                : state.selectedTab === 4
                                  ? referralData?.affiliatesReferrals?.length * 50
                                  : state.selectedTab === 5
                                    ? referralData?.partnerReferrals?.length * 50
                                    : state.selectedTab === 6
                                      ? referralData?.referrals?.length * 50
                                      : 0
                            }`,
                          backgroundColor: "#D8F3F4",
                          color: "#008B90",
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
              <hr />
              {state.selectedTab === 1 ? (
                <ReferralUserComponent
                  pageChanger={pageChangeButtonHandler}
                  selectedTab={state.selectedTab}
                  showSearch={state.showSearch}
                />
              ) : null || state.selectedTab === 2 ? (
                <ReferralVendorComponent
                  pageChanger={pageChangeButtonHandler}
                  selectedTab={state.selectedTab}
                  showSearch={state.showSearch}
                />
              ) : null || state.selectedTab === 3 ? (
                <ReferralSalesComponent
                  pageChanger={pageChangeButtonHandler}
                  selectedTab={state.selectedTab}
                  showSearch={state.showSearch}
                />
              ) : null || state.selectedTab === 4 ? (
                <ReferralAffiliatesComponent
                  pageChanger={pageChangeButtonHandler}
                  selectedTab={state.selectedTab}
                  showSearch={state.showSearch}
                />
              ) : null || state.selectedTab === 5 ? (
                <ReferralPartnersComponent
                  pageChanger={pageChangeButtonHandler}
                  selectedTab={state.selectedTab}
                  showSearch={state.showSearch}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SuperAdminReferralsCode;

export const TopNavigationReferralTab = (props) => {
  return (
    <div className="col-9 d-flex align-items-center">
      <div
        className=" mr-3 f14-400 cursor-pointer"
        onClick={() => props.pageChanger(1)}
        style={{
          borderBottom: props.selectedTab === 1 ? "4px solid #f85032" : "",
          color: props.selectedTab === 1 ? "#f85032" : "black",
        }}
      >
        <h5>User</h5>
      </div>
      <div
        className="ml-3 mr-3 f14-400 cursor-pointer"
        onClick={() => props.pageChanger(2)}
        style={{
          borderBottom: props.selectedTab === 2 ? "4px solid #f85032" : "",
          color: props.selectedTab === 2 ? "#f85032" : "black",
        }}
      >
        <h5>Merchant</h5>
        {/* <hr className={props.selectedTab === 2 ? "hr-bottom" : "d-none"} /> */}
      </div>
      <div
        className="ml-3 mr-3 f14-400 cursor-pointer"
        // onClick={() => props.pageChanger(3)}
        disabled={true}
        style={{
          borderBottom: props.selectedTab === 3 ? "4px solid #f85032" : "",
          color: props.selectedTab === 3 ? "#f85032" : "black",
        }}
      >
        <h5>Sales Representative</h5>
        {/* <hr className={props.selectedTab === 3 ? "hr-bottom" : "d-none"} /> */}
      </div>
      <div
        className="ml-3 mr-3 f14-400 cursor-pointer"
        onClick={() => props.pageChanger(4)}
        disabled={true}
        style={{
          borderBottom: props.selectedTab === 4 ? "4px solid #f85032" : "",
          color: props.selectedTab === 4 ? "#f85032" : "black",
        }}
      >
        <h5>Affiliates</h5>
        {/* <hr className={props.selectedTab === 4 ? "hr-bottom" : "d-none"} /> */}
      </div>
      <div
        className="ml-3 mr-3 f14-400 cursor-pointer"
        // onClick={() => props.pageChanger(5)}
        disabled={true}
        style={{
          borderBottom: props.selectedTab === 5 ? "4px solid #f85032" : "",
          color: props.selectedTab === 5 ? "#f85032" : "black",
        }}
      >
        <h5>Partners</h5>
        {/* <hr className={props.selectedTab === 5 ? "hr-bottom" : "d-none"} /> */}
      </div>
    </div>
  );
};
